// @ts-nocheck
import { NotificationsFollowedModel } from "@insite/client-framework/Types/ApiModels";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<NotificationsFollowedModel>;

export const dispatchSetAdditionalAccountSettingsValues: HandlerType = props => {
    props.dispatch({
        type: "Greif/PagesReducer/AccountSettings/SetAdditionalAccountSettingsValues",
        followNewPrice: props.parameter.followNewPrice,
        followNewFeature: props.parameter.followNewFeature,
        followNewTec: props.parameter.followNewTec,
        followUpcomingShipment: props.parameter.followUpcomingShipment,
        followOrderShipped: props.parameter.followOrderShipped,
        followOrderPickup: props.parameter.followOrderPickup,
        followOrderChange: props.parameter.followOrderChange,
        language: props.parameter.language,
    });
};

export const chain = [dispatchSetAdditionalAccountSettingsValues];
const setAdditionalAccountSettingsValues = createHandlerChainRunner(chain, "setAdditionalAccountSettingsValues");
export default setAdditionalAccountSettingsValues;
